<template>
  <div id="valuedAccountReport">
    <el-card>
      <el-form :model="searchForm" ref="searchForm" label-position="top" @keyup.enter.native="handleSearch">
        <el-row>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Country:" prop="country">
              <el-select filterable clearable v-model="searchForm.country" placeholder="Please select">
                <el-option v-for="item in countryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Name:" prop="accountName">
              <el-input clearable v-model="searchForm.accountName" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Level:" prop="accountLevel">
              <el-select clearable v-model="searchForm.accountLevel" placeholder="Please select">
                <el-option v-for="item in accountLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Marketing KA/WLA:" prop="marketingKA">
              <el-select clearable v-model="searchForm.marketingKA" placeholder="Please select">
                <el-option v-for="item in marketingKAList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Industry:" prop="industry">
              <el-select filterable clearable v-model="searchForm.industry" placeholder="Please select">
                <el-option v-for="item in industryList" :key="item.value" :label="item.meaning" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Account Service No.(GTS):" prop="serviceNo">
              <el-input clearable v-model="searchForm.serviceNo" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="VIP CODE:" prop="vipCode">
              <el-input clearable v-model="searchForm.vipCode" placeholder="Please input" />
            </el-form-item>
          </el-col>
          <!-- <el-col :xl="6" :lg="8" :md="12">
            <el-form-item label="Labour Hour:" prop="labourHour">
              <el-input clearable v-model="searchForm.labourHour" placeholder="Please input" />
            </el-form-item>
          </el-col> -->
          <el-col :xl="6" :lg="16" :md="12" class="btn-col" style="text-align: right;">
            <el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
            <el-button size="small" @click="handleReset()">Reset</el-button>
            <el-button size="small" :loading="exportLoading" @click="handleExport()">Export</el-button>
          </el-col>
        </el-row>
      </el-form>

      <el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}" @sort-change="handleSortChange">
        <el-table-column prop="accountName" label="Account Name" align="left" min-width="180" fixed="left" :show-overflow-tooltip="true" sortable="custom">
          <template slot-scope="scope">
            <a style="color:blue;cursor:pointer;" @click="handleDetail(scope.row)">{{ scope.row.accountName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="country" label="Country" align="center" min-width="120" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="accountLevel" label="Account Level" align="center" min-width="140" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="marketingKa" label="Marketing KA/WLA" align="center" min-width="175" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="accountIndustry" label="Account Industry" align="center" min-width="170" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="gtsCode" label="Account Service No.(GTS)" align="center" min-width="215" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="vipCode" label="VIP CODE" align="center" min-width="130" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="labourHour" label="Labour Hour" align="center" min-width="130" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <!-- <el-table-column prop="caseQty" label="Case Number" align="center" min-width="135" :show-overflow-tooltip="true" sortable="custom"></el-table-column> -->
        <el-table-column prop="sparePartsQty" label="Spare Parts Replacement" align="center" min-width="150" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="majorProjectQty" label="Major Projects Number" align="center" min-width="150" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="pocQty" label="POC Number" align="center" min-width="140" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
        <el-table-column prop="equipmentQty" label="Install Base" align="center" min-width="135" :show-overflow-tooltip="true" sortable="custom"></el-table-column>
      </el-table>

      <div class="pageDiv" v-if="totalCount && totalCount > 0">
        <el-pagination
          small
          layout="total, prev, pager, next, sizes, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalCount"
          @size-change="changePageSize"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ValuedAccountReport',
  created() {
    this.initDropdownData()
    this.handleSearch()
  },
  data() {
    return {
      moment,
      // Search form
      searchForm: {},
      // Dropdown options
      countryList: [],
      accountLevelList: [],
      marketingKAList: [],
      industryList: [],
      // Table
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      // Sort
      sortField: '',
      sortOrder: '',
      // Export
      exportLoading: false,
    }
  },
  methods: {
    initDropdownData() {
      // keyValue/queryLabelList: AccountLevel, MarketingKa
      let kvUrl = `${this.$store.state.islhurl}keyValue/queryLabelList?`
      const kvKeys = ['AccountLevel', 'MarketingKa']
      kvKeys.forEach((k, i) => { kvUrl += (i === 0 ? '' : '&') + `keyList=${k}` })
      this._get(kvUrl).then(res => {
        if (res.code === 200 && res.data) {
          this.accountLevelList = res.data.AccountLevel || []
          this.marketingKAList = res.data.MarketingKa || []
        }
      }).catch(() => {})
      // lov/ipms/options: Country, Industry
      const lovCodes = 'HPFM.OVERSEA_COUNTRY,HPFM.SUB_INDUSTRY'
      const lovUrl = `${this.$store.state.islhurl}lov/ipms/options?lovCodes=${encodeURIComponent(lovCodes)}`
      this._get(lovUrl).then(res => {
        if (res.code === 200 && res.data) {
          const sortByOrder = (arr) => (arr || []).sort((a, b) => (a.orderSeq || 0) - (b.orderSeq || 0))
          this.countryList = sortByOrder(res.data['HPFM.OVERSEA_COUNTRY'])
          this.industryList = sortByOrder(res.data['HPFM.SUB_INDUSTRY'])
        }
      }).catch(() => {})
    },
    _mapSortField(prop) {
      const map = {
        accountName: 'accountName',
        country: 'country',
        accountLevel: 'accountLevel',
        marketingKa: 'marketingKa',
        accountIndustry: 'accountIndustry',
        gtsCode: 'gtsCode',
        vipCode: 'vipCode',
        labourHour: 'labourHour',
        caseQty: 'caseQty',
        sparePartsQty: 'sparePartsQty',
        majorProjectQty: 'majorProjectQty',
        pocQty: 'pocQty',
        equipmentQty: 'equipmentQty',
      }
      return map[prop] || prop
    },
    handleSearch() {
      this.currentPage = 1
      this._doSearch()
    },
    _doSearch() {
      const values = this.searchForm
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        country: values.country || undefined,
        accountName: values.accountName || undefined,
        accountLevel: values.accountLevel || undefined,
        marketingKa: values.marketingKA || undefined,
        accountIndustry: values.industry || undefined,
        gtsCode: values.serviceNo || undefined,
        vipCode: values.vipCode || undefined,
        sortField: this.sortField ? this._mapSortField(this.sortField) : undefined,
        sortOrder: this.sortOrder === 'ascending' ? 'asc' : (this.sortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') delete params[key]
      })

      this.tableLoading = true
      let url = `${this.$store.state.islhurl}valued-account/report`
      this.$axios.get(url, { params }).then(res => {
        this.tableLoading = false
        const data = res.data
        if (data.code === 200) {
          this.tableData = data.data || []
          this.totalCount = data.totalSize || 0
        } else {
          this.tableData = []
          this.totalCount = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.tableLoading = false
        this.tableData = []
        this.totalCount = 0
      })
    },
    changePageSize(size) {
      this.pageSize = size
      this.handleSearch()
    },
    changePage(current) {
      this.currentPage = current
      this._doSearch()
    },
    handleReset() {
      this.searchForm = {}
      this.sortField = ''
      this.sortOrder = ''
      this.currentPage = 1
      this._doSearch()
    },
    handleSortChange({ prop, order }) {
      this.sortField = order ? (prop || '') : ''
      this.sortOrder = order || ''
      this._doSearch()
    },
    handleDetail(row) {
      this.$router.push({ name: 'accountDetail', params: { id: row.customerId }, query: { from: 'valuedAccountReport' } })
    },
    handleExport() {
      const values = this.searchForm
      let params = {
        country: values.country || undefined,
        accountName: values.accountName || undefined,
        accountLevel: values.accountLevel || undefined,
        marketingKa: values.marketingKA || undefined,
        accountIndustry: values.industry || undefined,
        gtsCode: values.serviceNo || undefined,
        vipCode: values.vipCode || undefined,
      }
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === '') delete params[key]
      })

      this.exportLoading = true
      let url = `${this.$store.state.islhurl}valued-account/report/export`
      this.$axios({
        url,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        const data = response.data
        if (data.type && data.type.includes('application/json')) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result)
              this.$message.error(err.msg || 'Export failed!')
            } catch (e) {
              this.$message.error('Export failed!')
            }
          }
          reader.readAsText(data)
          return
        }
        const fileName = 'ValuedAccountReport_' + moment().format('YYYYMMDDHHmmss') + '.xlsx'
        const blob = new Blob([data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = fileName
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.$message.error('Export failed!')
      }).finally(() => {
        this.exportLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
#valuedAccountReport {
  .btn-col {
    padding: 30px 0 0 0px;
  }
  .el-form {
    padding: 20px 0 20px 0;
    .el-form-item {
      margin-bottom: 0px;
      padding: 0 15px 0 0;
    }
    /deep/.el-form-item__label {
      line-height: 22px;
      padding: 4px 12px 0px 0px;
    }
    /deep/.el-select {
      width: 100%;
    }
    /deep/.el-form-item__content .el-input__suffix {
      left: auto;
      right: 10px;
    }
    /deep/.el-range-editor.el-input__inner {
      width: 100%;
    }
  }
  .el-table {
    /deep/th.el-table__cell > .cell {
      word-break: break-word;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/valuedAccountReport.vue